<template>
  <div>
    <div
      class="ui-error-card flex flex-col items-center rounded-xl px-4 pb-4 pt-7"
    >
      <!-- prettier-ignore -->
      <svg xmlns="http://www.w3.org/2000/svg" width="35" height="36" fill="none"><path stroke="#F73D34" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M22.69 12.812 12.311 23.188m10.379 0L12.311 12.812"/><path stroke="#F73D34" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.5 34.5v0C8.386 34.5 1 27.113 1 18v0C1 8.886 8.386 1.5 17.5 1.5v0C26.613 1.5 34 8.886 34 18v0c0 9.113-7.387 16.5-16.5 16.5Z" clip-rule="evenodd"/></svg>

      <div class="mt-5 text-center">
        <h1 class="font-bold text-red-500">{{ $t('error-card.title') }}</h1>
        <p class="mt-2 leading-6">
          {{ $t('error-card.description') }}
        </p>

        <div
          v-if="withButtons"
          class="mt-4 grid gap-4"
          :class="isDesktop ? 'grid-cols-2' : 'grid-cols-1'"
        >
          <UiPrimaryButton
            v-if="withReloadButton"
            class="w-full"
            @click="emit('onReload')"
          >
            {{ $t('error-card.reload-button') }}
          </UiPrimaryButton>
          <button
            v-if="withBackButton"
            type="button"
            class="ui-error-card-back-button-bg-color h-12 w-full rounded-xl font-bold ring-gray-50 duration-100 hover:text-gray-700 hover:ring-1 active:scale-[.99] active:ring-2"
            @click="emit('onGoBack')"
          >
            {{ backButtonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import i18next from 'i18next';
  import UiPrimaryButton from './UiPrimaryButton.vue';

  const props = withDefaults(
    defineProps<{
      /**
       * @todo
       * подумать как лучше передавать контекст по экранам,
       * использовать пропс или appContext или css media queries
       * */

      isDesktop?: boolean;
      withReloadButton?: boolean;
      withBackButton?: boolean;
      backButtonText?: string;
    }>(),
    {
      withReloadButton: false,
      withBackButton: false,
      backButtonText: () => i18next.t('error-card.back-button'),
    },
  );

  const emit = defineEmits<{
    (e: 'onReload'): void;
    (e: 'onGoBack'): void;
  }>();

  const withButtons = computed(
    () => props.withBackButton || props.withReloadButton,
  );
</script>

<style scoped>
  .ui-error-card {
    background-color: var(--ui-error-card-bg-color, theme('colors.gray.75'));
  }
  .ui-error-card-back-button-bg-color {
    background-color: var(
      --ui-error-card-back-button-bg-color,
      theme('colors.white')
    );
  }
</style>
